import React from "react";
import { Body2 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { PublicInvoiceObjectAmount } from "~/components/InvoiceObject/PublicInvoiceObjectAmount";
import { NlToBr } from "~/components/Text/NlToBr";

export const PublicInvoiceObjectItemRow = ({ index, currency, item }) => {
  return (
    <tr className="row">
      <td className={classNames("cell order")}>
        <div className={classNames("table-cell-wrapper")}>
          <Body2 align="center">{index + 1}</Body2>
        </div>
      </td>
      <td className="cell description">
        <div className="table-cell-wrapper">
          <Body2 className="tw-flex tw-flex-1 tw-items-start tw-px-2">
            <NlToBr>{item.description}</NlToBr>
          </Body2>
        </div>
      </td>
      <td className="cell quantity numeric">
        <div className="table-cell-wrapper">
          <Body2 className="tw-flex tw-flex-1 tw-justify-end tw-px-2">{item.quantity}</Body2>
        </div>
      </td>
      <td className="cell cost numeric">
        <div className="table-cell-wrapper">
          <Body2 className="tw-flex tw-flex-1 tw-justify-end tw-px-2">
            <PublicInvoiceObjectAmount
              currency={currency}
              total={item?.unit_cost}
              showCurrency
              trimDecimals={false}
              format="long"
            />
          </Body2>
        </div>
      </td>
      <td className="cell amount numeric">
        <div className="table-cell-wrapper">
          <Body2 className="tw-flex tw-flex-1 tw-justify-end tw-px-2">
            <PublicInvoiceObjectAmount
              currency={currency}
              total={item?.subtotal}
              showCurrency
              trimDecimals={false}
              format="long"
            />
          </Body2>
        </div>
      </td>
    </tr>
  );
};

PublicInvoiceObjectItemRow.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  currency: PropTypes.object,
};
